import { render, staticRenderFns } from "./smsDashboard.vue?vue&type=template&id=6422e264&scoped=true&"
import script from "./smsDashboard.vue?vue&type=script&lang=js&"
export * from "./smsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./smsDashboard.vue?vue&type=style&index=0&id=6422e264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6422e264",
  null
  
)

export default component.exports